.root {
    width: 100%;
    align-self: stretch;
    display: flex;
}

.list {
    justify-content: flex-start;
    gap: var(--mantine-spacing-lg);
    width: 100%;
    align-items: stretch;
    flex-wrap: nowrap;
}

.list::before {
    display: none !important;
}

.tab {
    border-bottom: 2px solid transparent;
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
    font-size: var(--mantine-font-size-sm);
    color: var(--mantine-color-gneis-8);
    background-color: transparent !important;
    /* Pull the tab down by 1px so its bottom border overlaps the topbar's
       bottom border — the blue indicator sits exactly on the gneis line. */
    margin-bottom: -1px;
    display: inline-flex;
    align-items: center;
}

.tab[data-active="true"] {
    color: var(--mantine-color-dibblue-9);
    border-bottom-color: var(--mantine-color-dibblue-6);
}

.tabLabel {
    display: inline-flex;
    align-items: center;
}

.tabIcon {
    color: var(--mantine-color-dibblue-9);
}

.searchTabIcon {
    color: var(--mantine-color-gneis-7);
    transition: color 150ms ease;
}

.tab[data-active="true"] .searchTabIcon {
    color: var(--mantine-color-dibblue-9);
}

.countPill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 18px;
    padding: 0 6px;
    border-radius: var(--mantine-radius-xl);
    background-color: var(--mantine-color-gneis-1);
    color: var(--mantine-color-dark-5);
    font-size: var(--mantine-font-size-xs);
    font-weight: 500;
    line-height: 1;
    flex-shrink: 0;
}

/* Active tab's count pill picks up the brand light-blue / blue treatment,
   per the v4 prototype. */
.tab[data-active="true"] .countPill {
    background-color: var(--mantine-color-dibblue-0);
    color: var(--mantine-color-dibblue-9);
}

@keyframes answerBadgePop {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    60% {
        transform: scale(1.25);
        opacity: 1;
    }
    80% {
        transform: scale(0.92);
    }
    100% {
        transform: scale(1);
    }
}

.answerBadge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: var(--mantine-color-dibblue-6);
    color: var(--mantine-color-white);
    flex-shrink: 0;
    transform-origin: center;
    animation: answerBadgePop 420ms cubic-bezier(0.34, 1.56, 0.64, 1) both;
    will-change: transform, opacity;
}

.answerBadgeIcon {
    stroke-width: 3;
}

@media (prefers-reduced-motion: reduce) {
    .answerBadge {
        animation: none;
    }
}
